import axios from 'axios';

// Calls that need no login. They use a bare axios instance so an old or missing token is never sent.
const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
});

const publicService = {
  // Redeem the emailed personal link: starts or resumes an application.
  redeemInvitation: async (token) => (await client.post(`/invitations/${token}/accept`)).data,

  // The shareable "apply for this property" link.
  getApplyLink: async (token) => (await client.get(`/apply-link/${token}`)).data,
  startFromApplyLink: async (token, data) => (await client.post(`/apply-link/${token}`, data)).data,

  // The public contact form.
  sendContactMessage: async (data) => (await client.post('/contact', data)).data,

  // Business identity (legal name, address, support contact) for the About/Terms/Privacy pages.
  // The single source of truth is the backend's .env — see config/site.js for how this is used.
  getSiteConfig: async () => (await client.get('/site-config')).data
};

export default publicService;
